require("angular");
require("./angular-gridflex");
module.exports = "hj.gridflex";
